import { S$ } from '@infl-ts/util-fp-ts';
import { LensProvider } from '@infl-ts/util-lens';
import { includesPermission, Permission, useAdminPermissions } from '@infl-ts/util-use-admin-permissions';
import { constNull, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import PureAdminBar from './admin-bar';
import { jsx as _jsx } from "react/jsx-runtime";
export var AdminBar = function AdminBar(_ref) {
  var jwt = _ref.jwt,
      currentHubURL = _ref.currentHubURL;
  return pipe(useAdminPermissions(undefined, jwt, currentHubURL), O.map(S$.makeWith({
    hasCorporateAccess: includesPermission(Permission.map.CorporateAccess),
    canViewLenses: includesPermission(Permission.map.ViewLens)
  })), O.match(constNull, function (_ref2) {
    var hasCorporateAccess = _ref2.hasCorporateAccess,
        canViewLenses = _ref2.canViewLenses;
    return hasCorporateAccess || canViewLenses ? /*#__PURE__*/_jsx(LensProvider, {
      children: /*#__PURE__*/_jsx(PureAdminBar, {
        hasCorporateAccess: hasCorporateAccess,
        canViewLenses: canViewLenses
      })
    }) : null;
  }));
};